/**
 * Manifest.ts
 * Module for managing the manifest file
 */
import { FeedbackType } from "./../../Constants";
import * as Utils from "./../../Utils";
export class Manifest {
  constructor(manifestType, appId, submitTime, type, clientFeedbackId, applicationGroup, telemetryGroup, webGroup) {
    this.manifestData = {
      appId: appId,
      application: applicationGroup,
      clientFeedbackId: clientFeedbackId,
      manifestType: manifestType,
      source: "Client",
      submitTime: submitTime,
      telemetry: telemetryGroup,
      type: sanitizeType(type),
      web: webGroup
    };
  }
  setComment(comment) {
    this.manifestData.comment = comment;
  }
  setEmail(email) {
    this.manifestData.email = email;
  }
  setCategory(category) {
    this.manifestData.telemetry = this.manifestData.telemetry || {};
    this.manifestData.telemetry.featureArea = category;
  }
  /**
   * Set freeform custom values in manifest. Throws if values are already set.
   * @param values the values as a JS object
   */
  setValues(values) {
    if (values) {
      for (let field in values) {
        if (values.hasOwnProperty(field)) {
          if (this.manifestData.hasOwnProperty(field)) {
            this.manifestData[field] = Utils.overrideValues(values[field], this.manifestData[field]);
          } else {
            this.manifestData[field] = values[field];
          }
        }
      }
    }
  }
  getContent() {
    return new Blob([JSON.stringify(this.manifestData)], {
      type: "application/json"
    });
  }
}
function sanitizeType(type) {
  if (type === "Survey") {
    return type;
  } else {
    return FeedbackType[type];
  }
}